import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from 'app/service/auth-service';

export const LandingPageGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  authService.setIsLoggedIn(!(state.url === '/'));
  return !(state.url === '/');
};